import {AppSetting} from '../AppSetting';
import {AppSettingApi} from '../AppSettingApi';
import {BaseService} from '../Service/BaseService';
import {BaseWebApiDAO} from './BaseWebApiDAO';
import {HtmlMailDTOInterface} from '../DTO/HtmlMailDTOInterface';
import {toCamel} from '../Util/SnakeCamelUtil';

/**
 * HtmlMailDAO
 * HTMLメールDAO
 */
export class HtmlMailDAO extends BaseWebApiDAO {

	constructor(svc: BaseService) {
		super(svc);
	}

	/**
	 * テンプレート一覧取得
	 */
	public async getList(): Promise<Array<HtmlMailDTOInterface>> {

		if (AppSetting.DEBUG_MODE_DUMYDATA) {
			return [] as Array<HtmlMailDTOInterface>;
		}

		const request = {t: this.token};
		const res = await this.postRequest(AppSettingApi.HTML_MAIL_LIST, request);
		// APIレスポンスの body フィールドを content にマッピング（body が存在しない場合は content をそのまま使用）
		const list = this.obj2Array(toCamel(res)) as Array<any>;
		return list.map(item => ({
			...item,
			content: item.body ?? item.content,
			body: undefined
		})) as Array<HtmlMailDTOInterface>;
	}

	/**
	 * 送信
	 * @param subject メール件名
	 * @param content HTML本文
	 * @param userIds 送信先ユーザーIDのカンマ区切り文字列
	 * @param sendLine LINE同時送信フラグ
	 */
	public async send(subject: string, content: string, userIds: string, sendLine: number): Promise<any> {

		this.log('HtmlMailDAO.send()');

		if (AppSetting.DEBUG_MODE_DUMYDATA) {
			return '';
		}

		const request: any = {
			t: this.token,
			subject,
			content,
			user_ids: userIds,
			send_line: sendLine
		};

		this.log(AppSettingApi.HTML_MAIL_SEND);
		this.log(request);

		return await this.postRequest(AppSettingApi.HTML_MAIL_SEND, request);
	}
}
